import React, { useEffect, useMemo, useState } from "react";
import { Form, Row, Table, Col, Pagination } from "react-bootstrap";


const selectedCheckboxes = new Set()
const mainbox = new Set()
function SearchDSResults(props) {
    const [choices, setChoices] = useState([])
    const [isAllSelected, setIsAllSelected] = useState(false)

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = useState(config)
        const sortedItems = useMemo(() => {
            let sortableItems = [...items]
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key].toLowerCase() < b[sortConfig.key].toLowerCase()) {
                        return sortConfig.direction === "ascending" ? -1 : 1
                    }
                    if (a[sortConfig.key].toLowerCase() > b[sortConfig.key].toLowerCase()) {
                        return sortConfig.direction === "ascending" ? 1 : -1
                    }
                    return 0
                })
            }
            return sortableItems
        }, [items, sortConfig])

        const requestSort = (key) => {
            let direction = "ascending"
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === "ascending"
            ) {
                direction = "descending"
            }
            setSortConfig({ key, direction })
        }
        return { items: sortedItems, requestSort, sortConfig }
    }
    const [resultsPerPage, setResultsPerPage] = useState(30)
    const [currentPage, setCurrentPage] = useState(1)
    const indexOfLastResult = currentPage * resultsPerPage
    const indexOfFirstResult = indexOfLastResult - resultsPerPage
    const { items, requestSort, sortConfig } = useSortableData(props.results)
    const currentResult = items.slice(indexOfFirstResult, indexOfLastResult)
    const [activePage, setActivePage] = useState(1)

    const getClassNamesFor = (name) => {
        if (!sortConfig) {
            return "fa fa-sort"
        } else if (sortConfig.key === name) {
            if (sortConfig.direction === "ascending") {
                return "fa fa-caret-up"
            } else {
                return "fa fa-caret-down"
            }
        } else {
            return "fa fa-sort"
        }
    }

    function selectAll() {
        // Select all items from all pages, not just current page
        selectedCheckboxes.clear()
        items.forEach((item) => {
            if (item && item["Name"]) {
                selectedCheckboxes.add(item["Name"])
            }
        })
        setChoices(Array.from(selectedCheckboxes))
        props.handler(Array.from(selectedCheckboxes))
    }

    function UnSelectAll() {
        selectedCheckboxes.clear()
        setChoices(Array.from(selectedCheckboxes))
        props.handler(Array.from(selectedCheckboxes))
    }

    function togglemainCheckbox(e) {
        const isChecked = e.target.checked
        setIsAllSelected(isChecked)
        if (isChecked) {
            selectAll()
        } else {
            UnSelectAll()
        }
    }

    function toggleCheckbox(e) {
        if (props.isMultiSelect) {
            if (selectedCheckboxes.has(e.target.value)) {
                selectedCheckboxes.delete(e.target.value)
            } else {
                selectedCheckboxes.add(e.target.value)
            }
            setChoices(Array.from(selectedCheckboxes))
            props.handleSelectedItems(Array.from(selectedCheckboxes))
        } else {
            selectedCheckboxes.clear();
            selectedCheckboxes.add(e.target.value);
            setChoices([e.target.value]);
            props.handleSelectedItems([e.target.value]);
        }
    }
    function handlePageChange(pageNumber) {
        setCurrentPage(pageNumber)
        setActivePage(pageNumber)
    }
    const info_content = currentResult.map((key, index) => (
        <tr key={index} style={{ display: "table", width: "100%", tableLayout: "fixed" }}>
            <td width="50px" align="center" style={{ width: "50px" }}>
                <Form.Check
                    type={props.isMultiSelect ? "checkbox" : "radio"}
                    name="tableCheckbox"
                    id={`tableCheckbox_${index}`}
                    value={key["Name"]}
                    onChange={toggleCheckbox}
                    checked={choices.includes(key["Name"]) ? true : false}
                />
            </td>
            <td style={{ width: "calc(100% - 50px)" }}>
                {key["Name"]}
            </td>
        </tr>
    ))
    useEffect(() => {
        selectedCheckboxes.clear();
        mainbox.clear();
        setIsAllSelected(false);
        setChoices([]);
    }, [props.results]);

    const totalPages = Math.ceil(props.results.length / resultsPerPage)

    const renderPaginationItems = () => {
        const items = []
        const maxPagesToShow = 3
        let startPage = Math.max(1, activePage - Math.floor(maxPagesToShow / 2))
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

        if (endPage - startPage + 1 < maxPagesToShow) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1)
        }

        if (activePage > 1) {
            items.push(
                <Pagination.First key="first" onClick={() => handlePageChange(1)} />,
                <Pagination.Prev key="prev" onClick={() => handlePageChange(activePage - 1)} />
            )
        }

        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item
                    key={page}
                    active={page === activePage}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </Pagination.Item>
            )
        }

        if (activePage < totalPages) {
            items.push(
                <Pagination.Next key="next" onClick={() => handlePageChange(activePage + 1)} />,
                <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
            )
        }

        return items
    }

    return (
        <React.Fragment>
            {props.error === 0 &&
                <React.Fragment>
                    <div
                        style={{ width: "100%" }}
                        id="paginTab"
                    >
                        <Pagination>{renderPaginationItems()}</Pagination>
                    </div>
                    <br />
                    <br />
                    <div className="DSTable">
                        <Table bordered className="table-responsive" style={{ tableLayout: "fixed", width: "100%" }}>
                            <thead id="template_summ_tab" style={{ display: "table", width: "100%", tableLayout: "fixed" }}>
                                <tr>
                                    {props.isMultiSelect ?
                                        <th width="50px" style={{ width: "50px" }}>
                                            <Form.Check
                                                type="checkbox"
                                                style={{ textAlign: "center" }}
                                                onChange={togglemainCheckbox}
                                                id="gridViewCheckbox"
                                                checked={isAllSelected}
                                            />
                                        </th>
                                        :
                                        (<th width="50px" style={{ width: "50px", paddingRight: "30px" }}>
                                        </th>)
                                    }
                                    <th style={{ width: "calc(100% - 50px)" }}>
                                        Name &nbsp;
                                        <i
                                            onClick={() => requestSort("Name")}
                                            className={getClassNamesFor("Name")}
                                        ></i>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>{info_content}</tbody>
                        </Table>
                    </div>
                </React.Fragment>
            }
            {props.error === 1 && (
                <Row className="mt-5">
                    <Col md="12" style={{ textAlign: "center" }}>
                        <span className="reportLabels">No Result Found</span>
                    </Col>
                </Row>
            )}
            {props.error === 2 && (
                <Row className="mt-5">
                    <Col md="12" style={{ textAlign: "center" }}>
                        <span className="reportLabels" style={{ color: "#a00505" }}>
                            Search service issue. Please contact SpecReaderExt.im@pg.com for help.
                        </span>
                    </Col>
                </Row>
            )}
        </React.Fragment >
    )
}
export default SearchDSResults